import { render, staticRenderFns } from "./AffiliatePaymentNotice.vue?vue&type=template&id=1b406520&scoped=true"
import script from "./AffiliatePaymentNotice.vue?vue&type=script&lang=js"
export * from "./AffiliatePaymentNotice.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/login.css?vue&type=style&index=0&id=1b406520&prod&scoped=true&lang=css&external"
import style1 from "./AffiliatePaymentNotice.vue?vue&type=style&index=1&id=1b406520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b406520",
  null
  
)

export default component.exports